// extracted by mini-css-extract-plugin
export default {"text":"sutherlin2021_text__JbBuw","main":"sutherlin2021_main__Twnrk","background":"sutherlin2021_background__TvwyM"};